import React from 'react';
import { contactCtaClick } from '../utils/analytics';
import type { ContactChannel, ContactCtaLocation, ContactService } from '../utils/analytics';

interface TrackedContactLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  channel: ContactChannel;
  service: ContactService;
  ctaLocation: ContactCtaLocation;
}

/** Lien WhatsApp / téléphone qui envoie contact_cta_click sans bloquer la navigation. */
const TrackedContactLink: React.FC<TrackedContactLinkProps> = ({
  channel,
  service,
  ctaLocation,
  onClick,
  children,
  ...anchorProps
}) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    contactCtaClick({ channel, service, cta_location: ctaLocation });
    onClick?.(event);
  };

  return (
    <a {...anchorProps} data-cta-location={ctaLocation} onClick={handleClick}>
      {children}
    </a>
  );
};

export default TrackedContactLink;
